import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function nativeLoad(_this__u8e3s4, url) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.tb5_1;
  var tmp0_safe_receiver = this_0.vb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver instanceof HTMLImageElement))
      THROW_CCE();
    tmp0_safe_receiver.onerror = (dyn, msg, a, b, c) => {
      _this__u8e3s4.dcc_1.pah(Companion_getInstance().uah(Exception().ud('Failed to load image: ' + msg)));
      return Unit_instance;
    };
    tmp0_safe_receiver.onload = (it) => {
      _this__u8e3s4.dcc_1.pah(_ReactiveState___init__impl__fvdp9b(Unit_instance));
      return Unit_instance;
    };
    tmp0_safe_receiver.src = url == null ? '' : url;
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.ub3_1.v((it) => {
      if (!(it instanceof HTMLImageElement))
        THROW_CCE();
      it.onerror = (dyn, msg, a, b, c) => {
        _this__u8e3s4.dcc_1.pah(Companion_getInstance().uah(Exception().ud('Failed to load image: ' + msg)));
        return Unit_instance;
      };
      it.onload = (it) => {
        _this__u8e3s4.dcc_1.pah(_ReactiveState___init__impl__fvdp9b(Unit_instance));
        return Unit_instance;
      };
      var tmp0_elvis_lhs = url;
      it.src = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  nativeLoad as nativeLoad3gm9heja6i3t0,
};
//endregion

//# sourceMappingURL=RawImageView.commonHtml.js.mjs.map
